
module library {
  'use strict';

  export class LibraryCtrl {


    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$scope',
      '$timeout',
      '$filter',
      'libraryService', 
      'anchorNavService',
      '$mdDialog',
    ];

    // dependencies are injected via AngularJS $injector
    // controller's name is registered in Application.ts and specified from ng-controller attribute in index.html
    constructor(
      private $scope: ILibraryControllerScope,
      private $timeout: ng.ITimeoutService,
      private $filter: misc.IAdvancedNumberFilter,
      private libraryService: ILibraryService,
      private anchorNavService : navigation.IAnchorNavService,
      private $mdDialog: ng.material.IDialogService
      ) {
      
      // 'vm' stands for 'view model'. We're adding a reference to the controller to the scope
      // for its methods to be accessible from view / HTML
      $scope.vm = this;

      // variables needed for pagination
      $scope.error = false;
      $scope.limit = 3;
      $scope.offset = 0;

      libraryService.loadDocumentsByProduct(pglob.RouteData.RouteEntry).then((response) => {
        $scope.data = response.data.Documents;
        $scope.languages = response.data.Languages;
      }).catch((err) => {
        $scope.error = true;
      });

      anchorNavService.subscribeOnLocationChanged($scope, (event :ng.IAngularEvent, re:IRouteEntry) => {
        libraryService.loadDocumentsByProduct(re).then((response) =>  {
          $scope.data = response.data.Documents;
          $scope.languages = response.data.Languages;
        }).catch((err) => {
          $scope.error = true;
        });    
      });      

      var queryRevId = anchorNavService.getQueryValue('revid');
      if (queryRevId && typeof queryRevId !== 'boolean' ) { 
        this.openDetailModalByRevId(null, parseInt(queryRevId));
      };

      // resets the offset when changing category (for example from pictures to documents)
      $scope.$watchCollection('selectedType.Documents', function (newCol, oldCol, scope) {
        if (newCol !== oldCol) {
          $scope.offset = 0;
        }
      })

    }

    public getTotalPages(nrofarticles: number): number {
      return Math.ceil(nrofarticles / 3);
    }

    public getCurrentPage(offset: number): number {
      var currentPage = offset / this.$scope.limit + 1;
      this.$scope.isFirstPage = currentPage == 1;
      if (this.$scope.selectedType && this.$scope.selectedType.Documents) {
        this.$scope.isLastPage = this.$scope.offset >= this.$scope.selectedType.Documents.length - this.$scope.limit;
      }
      return currentPage;
    }

    public nextPage() {
      if (!this.$scope.data || this.$scope.offset >= this.$scope.selectedType.Documents.length - this.$scope.limit) return;
      var newOffset = this.$scope.offset + this.$scope.limit;
      this.$scope.offset = newOffset;
    }

    public previousPage() {
      if (!this.$scope.data) return;
      var newOffset = this.$scope.offset - this.$scope.limit;
      this.$scope.offset = newOffset;
      if (this.$scope.offset < 0) {
        this.$scope.offset = 0;
        return;
      }
    }

    getLanguageName(hlCode : String):Language {
      var hl = this.$scope.languages.filter(function (item : Language, index :number, array : Language[]) {
        return item.LanguageCode == hlCode;
      });
      if (hl) return hl[0];
      return null;
    }

    getRevisionFileTypeDescription(rev : DocumentRev) : string {
      if (!rev.DocumentRevDestName) return rev.FileTypeName; //papiervorlage
      return rev.FileTypeExt + ' – ' + this.$filter('advancedNumber')(rev.DocumentRevDestSize,1024) +'B';// + ' (' + rev.FileTypeName + ')';
    }

    getDefaultRevision(doc :  Document, hl? : string, fileType? : String) {
      return this.libraryService.getDefaultRevision(doc, hl, fileType);
    }

    openDetailModal(ev: MouseEvent, d : Document,  rev : DocumentRev)  {      
      this.openDetailModalByRevId(ev, rev.DocumentFileSrcRevID, d, rev);
    }
    
      
    openDetailModalByRevId(ev: MouseEvent, revid : number, d? : Document,  rev? : DocumentRev)  {      
      this.libraryService.openDialog(revid, this.$scope, ev);
    }
      
    openSortModal(ev: MouseEvent, selectedType : DocumentType)  {
      this.$mdDialog.show(<ng.material.IDialogOptions>{
        controller: 'LibrarySortCtrl',
        templateUrl: 'library/LibrarySortCtrl',
        parent: angular.element(document.body),
        bindToController: true,
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          selectedType : selectedType
        },
      //}).then(() => {
      //}, () => {
      });
    }

  }

}